<script>
import Radio from 'element-ui/lib/radio';

export default Radio;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/radio.css';
// Adding RTL support to element's input

.el-radio {
  display: block;

  + & {
    margin-top: 15px;
  }

  &__label {
    font-size: $global-font-size;
  }

  @include rtl() {
    &__label {
      padding-left: 0;
      padding-right: 5px;
    }
  }

  @include breakpoint(large) {
    display: inline-block;

    @include rtl() {
      margin-right: auto;
      margin-left: 30px;
    }
  }
}
</style>
